/**
 * Overflow enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum OVERFLOW {
	NONE = "none",
	VERTICAL = "vertical",
	HORIZONTAL = "horizontal",
	BOTH = "both",
	VISIBLE = "visible"
}

export type OVERFLOW_string = keyof typeof OVERFLOW;

export const OVERFLOW_default: OVERFLOW_string = "NONE";
